import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGridSection from "./components/CategoryGridSection";
import FeatureGridSection from "./components/FeatureGridSection";
import ArticlePreviewSection from "./components/ArticlePreviewSection";
import SocialProofSection from "./components/SocialProofSection";
import CTASection from "./components/CTASection";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Pandabuy Spreadsheet",
  "url": "https://pandabuy.makeup/",
  "description": "The Ultimate Fashion Spreadsheet and Outfit Comparison Hub. Discover curated fashion spreadsheets, outfit breakdowns, and price comparison tables updated weekly across 14 product categories.",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://kaspreadsheet.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGridSection />
        <FeatureGridSection />
        <ArticlePreviewSection />
        <SocialProofSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}